import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";
import * as React from "react";
import { useContext } from "react";

interface SVGProps extends React.SVGProps<SVGSVGElement> {}

const DownloadIcon: React.FC<SVGProps> = (props) => {
  const { isDarkMode } = useContext(ThemeContext);
  const finalColor = props?.fill?.trim() ? props?.fill?.trim() : isDarkMode ? "#FFFFFF" : "#00132E";

  return (
    <svg
      width="23"
      height="21"
      viewBox="0 0 23 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: finalColor }}
      {...props}
    >
      <path
        d="M11.5 21C10.97 21 10.43 20.86 9.95 20.58L1.55 15.68C0.59 15.12 0 14.09 0 12.98V8.08C0 7.65 0.34 7.3 0.77 7.3C1.19 7.3 1.54 7.65 1.54 8.08V12.98C1.54 13.54 1.84 14.06 2.31 14.34L10.72 19.24C11.2 19.52 11.8 19.52 12.28 19.24L20.69 14.34C21.16 14.06 21.46 13.54 21.46 12.98V8.08C21.46 7.65 21.81 7.3 22.23 7.3C22.66 7.3 23 7.65 23 8.08V12.98C23 14.09 22.41 15.12 21.45 15.68L13.05 20.58C12.57 20.86 12.03 21 11.5 21Z"
        fill="currentColor"
      />

      <path
        d="M11.5 14.85C11.08 14.85 10.73 14.51 10.73 14.08V0.78C10.73 0.35 11.08 0 11.5 0C11.92 0 12.27 0.35 12.27 0.78V14.08C12.27 14.51 11.92 14.85 11.5 14.85Z"
        fill="currentColor"
      />

      <path
        d="M11.47 14.89C11.27 14.89 11.07 14.82 10.92 14.67L7.12 10.83C6.82 10.53 6.82 10.03 7.12 9.73C7.42 9.43 7.91 9.43 8.21 9.73L12.01 13.57C12.31 13.87 12.31 14.36 12.01 14.67C11.86 14.82 11.66 14.89 11.47 14.89Z"
        fill="currentColor"
      />

      <path
        d="M11.49 14.89C11.29 14.89 11.09 14.82 10.95 14.67C10.65 14.36 10.65 13.87 10.95 13.57L14.75 9.73C15.05 9.43 15.54 9.43 15.84 9.73C16.14 10.03 16.14 10.53 15.84 10.83L12.04 14.67C11.89 14.82 11.69 14.89 11.49 14.89Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DownloadIcon;
